import { AlertDialog, AlertDialogContent } from '@/components/ui/alert-dialog';
import { BlockButton } from '@/components/BlockButton';
import { showSuccessToast, showErrorToast } from '../../job_change_processes/lib/toast';
import useDeleteCandidateProfile from '../api/useDeleteCandidateProfile';

type Props = {
  candidateId: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export default function CandidatesDeleteModal({ candidateId, open, onOpenChange }: Props) {
  const { mutateAsync: deleteProfile } = useDeleteCandidateProfile();

  const handleDelete = async () => {
    try {
      await deleteProfile({ candidateProfileId: candidateId });
      showSuccessToast('削除しました');
      window.location.href = '/agent/candidates';
    } catch (error) {
      showErrorToast('削除に失敗しました');
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[728px]">
        <div className="flex h-[53px] items-center gap-1 border-b border-solid border-border px-6">
          <img src="/agent/candidates/icon-warning.svg" width={20} height={20} alt="" />
          <p className="text-sm font-bold text-danger">ご注意ください</p>
        </div>
        <div className="border-b border-solid border-border p-6">
          <p className="text-base">
            候補者を削除すると、転職進捗データ、売上データ含む関連する全てのデータが削除されます。
            削除した情報は復元できません。
          </p>
        </div>
        <div className="flex h-[74px] items-center justify-end gap-4 px-6">
          <div className="w-[94px]">
            <BlockButton
              type="button"
              colorType="white"
              text="キャンセル"
              onClick={() => onOpenChange(false)}
            />
          </div>
          <div className="w-[108px]">
            <BlockButton type="button" colorType="red" text="完全削除する" onClick={handleDelete} />
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
